import Field from "./Field";
import configuratorStore from '../../store/configuration';
import IssueExtenions from '../../components/common/IssueExtensions';

export default class StepModel {
    fields = []
    _firstVisibleField = null
    _lastVisibleField = null
    issues = []
    name = ''
    model = null
    editor = null

    constructor(name, model, editor) {
        this.name = name
        this.model = model
        this.editor = editor
    }

    initialize(fields, firstVisibleField, lastVisibleField) {
        this._fields = fields
        this._firstVisibleField = firstVisibleField
        this._lastVisibleField = lastVisibleField
        this.addFields(fields)
    }

    addField(field) {
        this.fields.push(field)
    }

    addFields(fields, it = 0) {
        for (let [name, instance] of Object.entries(fields)) {
            if (instance instanceof Field) {
                this.addField(instance)
            } else {
                this.addFields(instance, it++)
            }
        }
    }

    /**
     * @param {String} path Relative path to the field.
     * @return {Field}
     */
    getField(path) {
        let resultField = undefined

        this.fields.forEach(field => {
            let fieldPath = field.getUIPath()
            if (fieldPath.substr(this.name.length + 1, fieldPath.length) === path) {
                resultField = field
            }
        })

        return resultField
    }

    setIssues(issues) {
        this.issues = issues
    }

    getIssues() {
        return this.issues
    }

    hasIssues() {
        return this.issues.length > 0
    }

    hasIssuesAsForceToChange() {
        return IssueExtenions.hasForceToChange(this.issues);
    }

    hasIssuesAsWarning() {
        return IssueExtenions.hasWarnings(this.issues);
    }

    getTranslatedName() {
        let step = configuratorStore.getAvailableSteps().find(x => x.slug === this.name)
        if (step) {
            return step.name
        }

        return 'Unknown step'
    }

    getFirstVisibleField() {
        return this._firstVisibleField()
    }

    getLastVisibleField() {
        return this._lastVisibleField()
    }
}